import {
	CustomEmojiData,
	EventDisplayDataRSVPOption,
} from "../../../../../common/sesh_types";

export function InlineEmoji(props: {
	option: {
		custom_emoji_data?: Omit<
			CustomEmojiData,
			"guild_id" | "guild_name" | "name"
		>;
		emoji: string;
	};
}) {
	const option = props.option;

	let emoji_element: JSX.Element;
	let custom_emoji_data = option.custom_emoji_data;
	if (custom_emoji_data) {
		let image_url =
			`https://cdn.discordapp.com/emojis/${custom_emoji_data.id}.` +
			(custom_emoji_data.animated ? "gif" : "png");

		emoji_element = (
			<span className="emoji-img inline-block">
				<img className="" src={image_url}></img>
			</span>
		);
	} else {
		emoji_element = <span className="inline">{option.emoji}</span>;
	}

	return emoji_element;
}
